import exceljs from "exceljs";
import {saveAs} from "file-saver";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import { 
    mimeTypeMap, MyDate, onlyUnique
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Export({
    filterData
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const exportFunc = () => {
        if(!filterData.length){
            window.alert("No data to export.");
            return;
        }
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        // setShowLoader(true);
        //---------------------------------------------------------------
        const formTypes = filterData.map(d => d.form).filter(onlyUnique);
        for(const formType of formTypes){
            const data = filterData.filter(d => d.form === formType);
            const worksheet = workbook.addWorksheet(formType, {views: [{showGridLines: false}]});
            worksheet.state = "visible";
            worksheet.properties.defaultColWidth = 22.57;
            let rows = data.map(post => [
                post.projectName,
                post.category, 
                post.laborCategory, 
                post.laborName, 
                post.department, 
                post.workLogSubmitTimeExcel, 
                post.plannedTimeExcel
            ]);
            let columns = [
                { name: "Project Name", filterButton: true},
                { name: "Project Category", filterButton: true},
                { name: "Labor Category", filterButton: true},
                { name: "Labor Name", filterButton: true},
                { name: "Department", filterButton: true},
                { name: "Submit Time", filterButton: true},
                { name: "Planned Time", filterButton: true},
            ];
            const exceptionColumns = [];
            //---------------------------------------------------------------
            if(formType === "Equipment Damage Report"){
                exceptionColumns.push(2, 5);
                rows = data.map(post => [
                    JSON.parse(post.content ?? "{}")["Truck Number"] ?? "", 
                    JSON.parse(post.content ?? "{}")["Equipment Affected"] ?? "", 
                    post.formSubmitTime === "0000-00-00 00:00:00"?"":post.formSubmitTime, 
                    post.laborName ?? "", 
                    JSON.parse(post.content ?? "{}")["How was this equipment damaged?"] ?? "",
                    JSON.parse(post.content ?? "{}")["Action Status"] ?? "Created",
                ]);
                columns = [
                    { name: "Truck Number", filterButton: true},
                    { name: "Equipment Affected", filterButton: true},
                    { name: "Date Reported", filterButton: true},
                    { name: "Reported By", filterButton: true}, 
                    { name: "Discrepancy", filterButton: true}, 
                    { name: "Status", filterButton: true},
                ];
            }
            if(formType === "Incident Report"){
                exceptionColumns.push(3, 4);
                rows = data.map(post => [
                    JSON.parse(post.content ?? "{}")["Date of Incident"] ?? "", 
                    post.laborName ?? "", 
                    JSON.parse(post.content ?? "{}")["Incident Information"] ?? "",
                    JSON.parse(post.content ?? "{}")["What happened?"] ?? "",
                    JSON.parse(post.content ?? "{}")["Action Status"] ?? "Created",
                ]);
                columns = [
                    { name: "Date of Incident", filterButton: true},
                    { name: "Reported By", filterButton: true}, 
                    { name: "Incident Information", filterButton: true}, 
                    { name: "What happened?", filterButton: true}, 
                    { name: "Status", filterButton: true},
                ];
            }
            if(formType === "Weekly Maintenance Zerk Fittings"){
                exceptionColumns.push(2, 5);
                rows = data.map(post => [
                    JSON.parse(post.content ?? "{}")["Truck Number"] ?? "", 
                    JSON.parse(post.content ?? "{}")["Driver"] ?? "", 
                    JSON.parse(post.content ?? "{}")["Date"] === "0000-00-00"?"":JSON.parse(post.content ?? "{}")["Date"], 
                    JSON.parse(post.content ?? "{}")["Location"] ?? "", 
                    JSON.parse(post.content ?? "{}")["Battery powered or electric grease gun 10,000 psi used."] ?? "",
                    JSON.parse(post.content ?? "{}")["Action Status"] ?? "Created",
                ]);
                columns = [
                    { name: "Truck Number", filterButton: true},
                    { name: "Driver", filterButton: true},
                    { name: "Date", filterButton: true},
                    { name: "Location", filterButton: true}, 
                    { name: "Battery powered or electric grease gun 10,000 psi used.", filterButton: true}, 
                    { name: "Status", filterButton: true},
                ];
            }
            //---------------------------------------------------------------
            worksheet.addTable({
                name: `MyTable${formType.replace(/ /g, "")}`,
                ref: "A1",
                totalsRow: false,
                style: {
                    showRowStripes: true,
                },
                columns, 
                rows,
            });
            if(formType === "Equipment Damage Report"){
                const linkCol = 6;
                for(let i = 0; i < data.length; i++){
                    const post = data[i];
                    const value = worksheet.getRow(2 + i).getCell(linkCol).value;
                    worksheet.getRow(2 + i).getCell(linkCol).value = {
                        text: value,
                        hyperlink: `http://besstestlab.netlify.app/Projects/${post.projectHashKey}/WorkInstructions/${post.workInstructionHashKey}/WorkLogs/${post.workLogHashKey}/${post.hashKey}`,
                        tooltip: value
                    }
                }
            }
            if(formType === "Incident Report"){
                const linkCol = 5;
                for(let i = 0; i < data.length; i++){
                    const post = data[i];
                    const value = worksheet.getRow(2 + i).getCell(linkCol).value;
                    worksheet.getRow(2 + i).getCell(linkCol).value = {
                        text: value,
                        hyperlink: `http://besstestlab.netlify.app/Projects/${post.projectHashKey}/WorkInstructions/${post.workInstructionHashKey}/WorkLogs/${post.workLogHashKey}/${post.hashKey}`,
                        tooltip: value
                    }
                }
            }
            worksheet.columns.forEach(column => {
                if(exceptionColumns.includes(column.number)){
                    column.width = 50;
                    return;
                }
                const minLength = 18;
                let maxLength = 0;
                column["eachCell"]({ includeEmpty: true }, cell => {
                    // exclude row 1 ----------
                    if(cell.row === 1) return;
                    //-------------------------
                    const columnLength = cell.value?
                    cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.3)
                    :minLength;
                    if(columnLength > maxLength){
                        maxLength = columnLength;
                    }
                });
                column.width = maxLength < minLength ? minLength : maxLength;
            });
            worksheet.getRows(2, rows.length).forEach(row => {row.alignment = { vertical: "middle", horizontal: "center", wrapText: true }});
        }
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), `projects forms export ${(new MyDate()).s()}.xlsx`);
            setShowLoader(false);
        })
    }
    return (
        <span className = "pointer" onClick = {exportFunc}>
            Export
        </span>
    )
}